__webpack_require__.p = "https://criipto-qr-demo-prod.netlify.app/";